import { memo } from "react";

interface VirtualSpacerRowProps {
  height: number;
  colSpan: number;
}

/**
 * A spacer row used in virtualized tables to create empty space for unrendered rows.
 * This is used to maintain the correct scroll height in virtualized tables when not all
 * rows are rendered at once.
 */
function VirtualSpacerRow(props: VirtualSpacerRowProps) {
  const { height, colSpan } = props;
  if (height <= 0) return null;
  return (
    <tr aria-hidden>
      <td colSpan={colSpan} style={{ height, padding: 0, border: 0 }} />
    </tr>
  );
}

export default memo(VirtualSpacerRow);
